export default "__VITE_ASSET__BjSNbsaX__"